import 'dayjs/locale/it'
import { Dayjs } from 'dayjs'

const it = {
  calendar: {
    sameDay: function (now: Dayjs) {
      return now.format('[Oggi a' + (now.hour() > 1 ? 'lle ' : now.hour() === 0 ? ' ' : "ll'") + ']LT')
    },
    nextDay: function (now: Dayjs) {
      return now.format('[Domani a' + (now.hour() > 1 ? 'lle ' : now.hour() === 0 ? ' ' : "ll'") + ']LT')
    },
    nextWeek: function (now: Dayjs) {
      return now.format('dddd [a' + (now.hour() > 1 ? 'lle ' : now.hour() === 0 ? ' ' : "ll'") + ']LT')
    },
    lastDay: function (now: Dayjs) {
      return now.format('[Ieri a' + (now.hour() > 1 ? 'lle ' : now.hour() === 0 ? ' ' : "ll'") + ']LT')
    },
    lastWeek: function (now: Dayjs) {
      switch (now.day()) {
        case 0:
          return now.format('[La scorsa] dddd [a' + (now.hour() > 1 ? 'lle ' : now.hour() === 0 ? ' ' : "ll'") + ']LT')
        default:
          return now.format('[Lo scorso] dddd [a' + (now.hour() > 1 ? 'lle ' : now.hour() === 0 ? ' ' : "ll'") + ']LT')
      }
    },
    sameElse: 'L'
  }
}

export default it
